/**
 * News / Media tab — related headlines for this fixture (with thumbnails),
 * using the news object already fetched for the match.
 */
import { ExternalLink, Newspaper, Zap } from 'lucide-react';

const MatchMedia = ({ news }) => {
  const headlines = news?.headlines || [];
  const ai = news?.ai_preview;
  return (
    <div className="px-3 py-3 pb-6 space-y-3" data-testid="media-panel">
      {ai && (ai.headline || ai.summary) && (
        <div className="rounded-2xl bg-[var(--sk-surface)] p-4">
          <div className="flex items-center gap-1.5 mb-2">
            <Zap className="w-3.5 h-3.5 text-emerald-400" />
            <span className="text-[10px] font-black uppercase tracking-wider text-emerald-400">AI Match Preview</span>
          </div>
          {ai.headline && <div className="text-[13px] font-bold text-white leading-snug mb-1">{ai.headline}</div>}
          {ai.summary && <p className="text-[12px] text-zinc-300 leading-relaxed">{ai.summary}</p>}
          {ai.key_battle && <p className="text-[12px] text-zinc-400 mt-1.5"><span className="font-bold text-zinc-300">Key battle: </span>{ai.key_battle}</p>}
        </div>
      )}

      {headlines.length === 0 ? (
        <div className="rounded-2xl bg-[var(--sk-surface)] p-5 text-[12px] text-zinc-500 text-center">
          No related news found yet — check back closer to kick-off.
        </div>
      ) : (
        headlines.map((h, i) => {
          const img = h.image_url || h.image || h.thumbnail;
          return (
            <a
              key={i}
              href={h.url || h.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-2xl bg-[var(--sk-surface)] overflow-hidden hover:bg-white/[0.07] transition-colors"
              data-testid={`media-article-${i}`}
            >
              {img && (
                <div className="w-full aspect-[16/9] bg-black/30 overflow-hidden">
                  <img src={img} alt="" className="w-full h-full object-cover" loading="lazy"
                       onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }} />
                </div>
              )}
              <div className="p-3.5 flex items-start gap-2">
                {!img && <Newspaper className="w-4 h-4 text-accent shrink-0 mt-0.5" />}
                <div className="flex-1 min-w-0">
                  <div className="text-[13px] text-white leading-snug font-medium">{h.title || h.headline}</div>
                  <div className="text-[10px] text-zinc-500 mt-1 flex items-center gap-1">
                    {h.source && <span>{h.source}</span>}
                    <ExternalLink className="w-2.5 h-2.5" />
                  </div>
                </div>
              </div>
            </a>
          );
        })
      )}
    </div>
  );
};

export default MatchMedia;
